import React from "react";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

class DateField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      date: this.createDate(this.props.value),
      value: this.props.value
    };

    // This binding is necessary to make `this` work in the callback
    this.handleChange = this.handleChange.bind(this);
  }

  //not null, at least long enough for year month and day, parseable by accepted formats
  isAcceptedDate(date) {
    if (date === null) {
      return false;
    }

    if (date.toString().length < 10) {
      return false;
    }

    date = moment(date);

    if (date.year() < 1000) {
      return false;
    }

    if (
      !moment(date, "DD.MM.YYYY", true).isValid() &&
      !moment(date, "YYYY-MM-DD", true).isValid()
    ) {
      return false;
    }

    return true;
  }

  //returns null if not parseable or parsed moment
  createDate(date) {
    if (date === null) {
      return null;
    }

    date = date.trim();

    if (!this.isAcceptedDate(date)) {
      // console.log(`Could not parse date: ${date}`);
      return date;
    }

    // console.log(`parsing date ${date}`);

    let parsedDate = null;
    if (moment(date, "DD.MM.YYYY", true).isValid()) {
      parsedDate = moment(date, "DD.MM.YYYY", true);
    } else if (moment(date, "YYYY-MM-DD", true).isValid()) {
      parsedDate = moment(date, "YYYY-MM-DD", true);
    }

    return parsedDate;
  }

  handleChange(e) {
    const origvalue = e.target.value.trim();

    const newDate = this.createDate(origvalue);
    this.setState({ date: newDate });

    this.props.onChange(e);

    return true;
  }
  render() {
    const {
      name,
      label,
      className,
      min,
      max,
      onBlur,
      error,
      helperText
    } = this.props;
    return (
      <React.Fragment>
        <TextField
          type="date"
          name={name}
          label={label}
          className={className}
          onChange={this.handleChange}
          defaultValue={this.state.value}
          min={min}
          max={max}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
        />
      </React.Fragment>
    );
  }
}

export default DateField;
